import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {SettingsState} from "../../../store/settings/types";
import {APIState} from "../../../store/API/types";
import CheckboxComponent from "../../reusable/CheckboxComponent";
import { setLocalSettings, setTimeZone } from '../../../store/settings/actions';

const SettingsTimeZoneComponent = () => {
    const { timeZone } = useSelector<ApplicationState, SettingsState>(state => state.settings);
    const { username } = useSelector<ApplicationState, APIState>(state => state.API);
    const dispatch = useDispatch();
    const switchers = [
        {
            name: 'timeZoneLocal',
            value: 'timeZoneLocal',
            label: 'Local',
            checked: timeZone === 'Local'
        },
        {
            name: 'timeZoneUTC',
            value: 'timeZoneUTC',
            label: 'UTC',
            checked: timeZone === 'UTC'
        }
    ];

    const handler = (e: React.FormEvent<HTMLInputElement>) => {
        const zone = e.currentTarget.value === 'timeZoneUTC' ? 'UTC' : 'Local';
        dispatch(setTimeZone(zone));
        window.localStorage.setItem(`${username}/timeZone`, `${zone}`);
    };

    return <CheckboxComponent inputs={switchers}
                              title={'Time zone format: '}
                              handler={handler}
    />
};

export default SettingsTimeZoneComponent;